import BaseVideoInsight from '@/lib/search/discovery/classes/insights/video/BaseVideoInsight';

class VideoKeyword extends BaseVideoInsight {

}

export default VideoKeyword;
